const zh = {
  // Navigation
  nav_home: "\u9996\u9875",
  nav_explore: "\u63A2\u7D22",
  nav_workspace: "工作空间",
  ws_videos: "视频",
  ws_untitled: "无标题视频",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "视频失败",
  ws_failed_refunded: "您的积分已退回",
  ws_failed_dismiss: "解雇",
  ws_failed_retry: "再试一次",
  ws_failed_retrying: "开始…",
  ws_failed_banner_one: "视频生成失败",
  ws_failed_banner_many: "{n} 个视频失败",
  ws_failed_banner_body: "没有收取任何费用 - 信用额返回到您的帐户。再试一次，或选择不同的主题。",
  ws_empty_title: "这里还什么都没有。",
  ws_empty_body: "您制作的每个视频都会出现在这里，最新的在前。",
  ws_generate: "产生",
  ws_composer_placeholder: "描述一个教训\u2026",
  ws_placeholder_hw: "为作业命名...（可选）",
  ws_placeholder_lecture: "为讲座命名...（可选）",
  ws_placeholder_self_study: "你想学什么？",
  nav_search: "\u641C\u7D22\u89C6\u9891...",
  nav_search_yours: "搜索您的视频...",
  nav_notifications: "\u901A\u77E5",
  nav_mark_all_read: "\u5168\u90E8\u6807\u4E3A\u5DF2\u8BFB",
  nav_no_notifications: "\u6682\u65E0\u901A\u77E5",
  nav_no_notifications_sub: "\u5F53\u60A8\u7684\u89C6\u9891\u5C31\u7EEA\u65F6\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u60A8",
  nav_upgrade: "\u5347\u7EA7",
  nav_billing: "\u8D26\u5355",
  nav_settings: "\u8BBE\u7F6E",
  nav_contact: "\u8054\u7CFB\u6211\u4EEC",
  nav_api: "应用程序编程接口",
  nav_sign_out: "\u9000\u51FA\u767B\u5F55",
  nav_just_now: "\u521A\u521A",
  nav_minutes_ago: "{n}\u5206\u949F\u524D",
  nav_hours_ago: "{n}\u5C0F\u65F6\u524D",
  nav_days_ago: "{n}\u5929\u524D",
  nav_used_this_month: "\u672C\u6708\u5DF2\u4F7F\u7528 {used}/{cap}",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "本周已使用 {used}（共 {limit}）",
  nav_free_daily: "每周 4 个免费视频",
  // Settings
  settings_title: "\u8BBE\u7F6E",
  settings_profile: "\u4E2A\u4EBA\u8D44\u6599",
  settings_change_avatar: "\u66F4\u6362\u5934\u50CF",
  settings_cancel: "\u53D6\u6D88",
  settings_choose_wizard: "\u9009\u62E9\u4F60\u7684\u5DEB\u5E08",
  settings_display_name: "\u663E\u793A\u540D\u79F0",
  settings_your_name: "\u4F60\u7684\u540D\u5B57",
  settings_save: "\u4FDD\u5B58",
  settings_saving: "\u4FDD\u5B58\u4E2D...",
  settings_saved: "\u5DF2\u4FDD\u5B58",
  settings_save_failed: "\u4FDD\u5B58\u5931\u8D25",
  settings_email: "\u7535\u5B50\u90AE\u4EF6",
  settings_notifications: "\u901A\u77E5",
  settings_email_notif: "\u90AE\u4EF6\u901A\u77E5",
  settings_email_notif_desc: "\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u63A5\u6536\u66F4\u65B0\u548C\u516C\u544A",
  settings_language: "\u8BED\u8A00",
  settings_language_desc: "\u9009\u62E9\u5E94\u7528\u548C\u89C6\u9891\u65C1\u767D\u7684\u8BED\u8A00",
  settings_data_title: "您的数据",
  settings_data_desc: "下载与您的帐户关联的个人数据的副本 - 包括您的个人资料、视频、课程、会话和支持消息。不包括内部系统日志和派生的处理数据。",
  settings_data_download: "下载我的数据",
  settings_data_exporting: "正在准备……",
  settings_danger: "\u5371\u9669\u533A\u57DF",
  settings_delete_account: "\u5220\u9664\u8D26\u6237",
  settings_delete_desc: "\u6C38\u4E45\u5220\u9664\u60A8\u7684\u8D26\u6237\u548C\u6240\u6709\u76F8\u5173\u6570\u636E\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002",
  settings_delete_confirm: "\u8FD9\u5C06\u6C38\u4E45\u5220\u9664\u60A8\u7684\u8D26\u6237\u548C\u6240\u6709\u6570\u636E\u3002\u8BF7\u8F93\u5165 {keyword} \u786E\u8BA4\u3002",
  settings_delete_placeholder: "\u8F93\u5165 \"DELETE\" \u786E\u8BA4",
  settings_permanently_delete: "\u6C38\u4E45\u5220\u9664",
  settings_deleting: "\u5220\u9664\u4E2D...",
  explore_watch_now: "\u7ACB\u5373\u89C2\u770B",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "\u65E0\u9884\u89C8",
  explore_no_videos: "\u6682\u65E0\u89C6\u9891\uFF0C\u8BF7\u7A0D\u540E\u518D\u6765\uFF01",
  explore_featured_courses: "特色课程",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "返回探索",
  course_not_found: "该课程不可用。",
  // Home Page
  home_hero: "\u5B66\u4E60\u4EFB\u4F55\u77E5\u8BC6\uFF0C",
  home_hero_accent: "\u53EF\u89C6\u5316",
  home_placeholder: "\u4F60\u60F3\u5B66\u4EC0\u4E48\u6216\u89E3\u51B3\u4EC0\u4E48\u95EE\u9898\uFF1F",
  home_extracting: "\u6B63\u5728\u63D0\u53D6\u95EE\u9898...",
  home_videos_generated: "\u5c06\u751f\u6210 {n, plural, other {# \u4e2a\u89c6\u9891}}",
  home_credits: "{n, plural, other {# \u79ef\u5206}}",
  home_remaining: "\u672C\u6708\u5269\u4F59",
  home_enter_prompt: "\u8BF7\u8F93\u5165\u4F60\u60F3\u5B66\u4E60\u6216\u89E3\u51B3\u7684\u5185\u5BB9",
  home_popular: "\u70ED\u95E8\u8BFE\u7A0B",
  home_from_community: "\u6765\u81EA\u793E\u533A",
  home_community_sub: "\u770B\u770B\u5B66\u751F\u4EEC\u5728\u521B\u5EFA\u4EC0\u4E48",
  home_tips_label: "来自《魔法师》的魔法师",
  home_tips_title: "提示与技巧",
  home_tip1_title: "获取具体信息",
  home_tip1_desc: "不要输入整个主题。选择一个想法、一个概念、一个问题。",
  home_tip1_example: "DNA复制如何在真核细胞中进行",
  home_tip2_title: "说是给谁的",
  home_tip2_desc: "中学的解释看起来与大学的讲座完全不同。",
  home_tip2_example: "为刚学代数的人解释导数",
  home_tip3_title: "告诉魔法师你想要​​什么",
  home_tip3_desc: "示例、分步、实际应用 — 只要说出来，Magi 就会跟着做。",
  home_tip3_example: "水循环与现实世界的例子和总结",
  home_tip_try: "尝试类似的东西",
  home_proven_social: "在 Instagram 上关注我们",
  home_ig_desc_1: "\u8D85\u8FC7 ",
  home_ig_followers: "55,000 \u7C89\u4E1D",
  home_ig_desc_2: "每天在 Instagram 上观看我们的数学和科学视频。这些卷轴是用您在这里使用的相同引擎制成的。",
  home_view_profile: "\u67E5\u770B\u4E3B\u9875",
  home_subscribe_now: "\u7ACB\u5373\u8BA2\u9605",
  home_sub_monthly: "\u6708\u4ED8",
  home_sub_yearly: "\u5E74\u4ED8",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "节省 {pct}%",
  home_sub_per_month: "/ \u6708",
  home_sub_billed_monthly: "每月收取 ${amount} 美元",
  home_sub_processing: "\u5904\u7406\u4E2D...",
  home_sub_no_commitment: "\u65E0\u5408\u7EA6\u675F\u7F1A\uFF0C\u968F\u65F6\u53D6\u6D88\u3002",
  home_sub_secured: "\u7531 Stripe \u5B89\u5168\u4FDD\u969C",
  home_sub_headline: "通过 {plan} 解锁更多",
  home_sub_due_now: "现在到期",
  home_sub_trial_label: "{days}天的完全访问权限",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "今天，您需要为本月的 ​​${amount} 个视频支付 {n} 的费用。除非您先取消，否则在 {date} 将以 ${amount} 美元/月的价格续订 — 可以随时从结算中取消。",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "今天，您需要支付 ${trial} 的费用，即可获得 {days} 天的完全访问权限，上限为 {n} 个视频。试用期不会在 ${trial} 继续 - 在 {date}，它会自动变为 {planName}，每月 ${plan}（{full} 个视频），此后每月收取 ${plan} 费用，直到您取消为止。随时从账单中取消。",
  home_sub_card: "信用卡或借记卡",
  home_sub_billed_once_yearly: "每年收取一次 ${amount} 的费用",
  home_sub_billed_trial: "${amount} 天收费 {days}，然后每月按 ${renews} 续订",
  home_sub_switch_plan: "正在寻找 {plan}？",
  home_sub_replaces_plan: "替换您的 {plan} 计划。您的账单日期保持不变 - 向上移动现在收取差额，向下移动从您的下一次续订开始。",
  home_sub_change_now: "您已切换到 {plan}，已收取差额 {amount}。",
  home_sub_change_later: "您将于 {date} 切换到 {plan}。今日不收取费用。",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "\u6BCF\u6708 {n} \u4E2A\u89C6\u9891",
  // Pricing Page
  pricing_title: "\u5347\u7EA7\u60A8\u7684\u5957\u9910",
  pricing_monthly: "\u6708\u4ED8",
  pricing_yearly: "\u5E74\u4ED8",
  pricing_save: "\u7701 17%",
  pricing_best_value: "\u6700\u4F73\u4EF7\u503C",
  pricing_your_plan: "\u5F53\u524D\u5957\u9910",
  pricing_get_started: "\u5F00\u59CB\u4F7F\u7528",
  pricing_processing: "\u5904\u7406\u4E2D...",
  pricing_per_month: "/\u6708",
  pricing_billed_yearly: "\u5E74\u4ED8 ${amount}",
  pricing_videos_month: "{n, plural, other {# \u4e2a\u89c6\u9891}}/\u6708",
  pricing_manage_cancel: "管理或取消",
  pricing_manage_unavailable: "未找到可管理的订阅。请联系我们，我们会为您处理。",
  pricing_opening: "\u6253\u5F00\u4E2D...",
  billing_autorenew_monthly: "按 ${amount}/月 自动续订，直至您取消。",
  billing_autorenew_yearly: "按每年 ${amount} 的价格自动续订，直至您取消。",
  billing_autorenews_on: "自动续订 {date} · 随时取消",
  pricing_secured: "\u7531 Stripe \u5B89\u5168\u4FDD\u969C",
  pricing_login_required: "\u8BF7\u767B\u5F55\u540E\u8BA2\u9605",
  pricing_auth_error: "\u7528\u6237\u8BA4\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u5C1D\u8BD5\u9000\u51FA\u5E76\u91CD\u65B0\u767B\u5F55\u3002",
  pricing_feature_pdf: "PDF \u548C\u56FE\u7247\u63D0\u53D6",
  pricing_feature_quality: "\u66F4\u9AD8\u8D28\u91CF\u6A21\u578B",
  pricing_feature_speed: "\u66F4\u5FEB\u751F\u6210\u901F\u5EA6",
  pricing_feature_study: "\u5B66\u4E60\u4F1A\u8BDD",
  pricing_free_hint: "\u5F53\u524D\u4E3A\u514D\u8D39\u5957\u9910",
  // Billing Page
  billing_title: "\u8D26\u5355",
  billing_current_plan: "\u5F53\u524D\u5957\u9910",
  billing_payment_failed_title: "你的计划已暂停",
  billing_payment_failed_body: "我们无法收取 {amount}，因此您的计划已暂停。更新您的卡以重新启动 - 我们也会继续重试。",
  billing_payment_failed_cta: "处理付款",
  billing_change_plan: "\u66F4\u6362\u5957\u9910",
  billing_invoices: "\u53D1\u7968",
  billing_loading: "\u52A0\u8F7D\u53D1\u7968\u4E2D...",
  billing_no_invoices: "\u6682\u65E0\u53D1\u7968",
  billing_date: "\u65E5\u671F",
  billing_amount: "\u91D1\u989D",
  billing_status: "\u72B6\u6001",
  billing_invoice: "\u53D1\u7968",
  billing_view: "\u67E5\u770B",
  // Contact Page
  contact_title: "\u8054\u7CFB\u6211\u4EEC",
  contact_placeholder: "\u6709\u4EC0\u4E48\u53EF\u4EE5\u5E2E\u60A8\u7684\uFF1F",
  contact_sent_desc: "\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u56DE\u590D\u60A8\u3002",
  contact_signin: "请登录以联系支持人员。",
  // Generation Queue
  queue_title: "\u961F\u5217",
  queue_active: "{n} \u4E2A\u8FDB\u884C\u4E2D",
  queue_generating: "{n} \u4E2A\u751F\u6210\u4E2D",
  queue_ready: "\u5DF2\u5B8C\u6210",
  queue_in_queue: "正在排队等待...",
  queue_almost_ready: "\u5373\u5C06\u5C31\u7EEA...",
  queue_seconds_left: "\u5269\u4F59 {n} \u79D2",
  queue_minutes_left: "\u5269\u4F59 {m}\u5206{s}\u79D2",
  queue_watch_now: "\u7ACB\u5373\u89C2\u770B",
  queue_waiting: "\u7B49\u5F85\u961F\u5217\u4E2D...",
  queue_empty: "\u961F\u5217\u4E2D\u65E0\u89C6\u9891",
  queue_empty_sub: "\u751F\u6210\u89C6\u9891\u540E\u5C06\u663E\u793A\u5728\u6B64\u5904",
  queue_clear: "\u6E05\u9664\u5168\u90E8",
  queue_total: "\u5171 {n} \u4E2A",
  queue_first_time: "\u60A8\u7684\u89C6\u9891\u6B63\u5728\u751F\u6210",
  queue_first_time_sub: "\u901A\u5E38\u7EA6 2 \u5206\u949F\u3002\u5B8C\u6210\u65F6\u4F1A\u6709\u63D0\u793A\u97F3\u3002",
  // Session Expired
  session_expired: "\u4F1A\u8BDD\u5DF2\u8FC7\u671F",
  session_expired_desc: "\u51FA\u4E8E\u5B89\u5168\u539F\u56E0\uFF0C\u60A8\u7684\u4F1A\u8BDD\u5DF2\u8FC7\u671F\u3002\u8BF7\u91CD\u65B0\u767B\u5F55\u4EE5\u7EE7\u7EED\u3002",
  // Cookie Banner
  cookie_text: "\u6211\u4EEC\u4F7F\u7528 Cookie \u6765\u5206\u6790\u7F51\u7AD9\u6D41\u91CF\u5E76\u6539\u5584\u60A8\u7684\u4F53\u9A8C\u3002\u9ED8\u8BA4\u4EC5\u8BBE\u7F6E\u5FC5\u8981\u7684 Cookie\u3002",
  cookie_learn_more: "\u4E86\u89E3\u66F4\u591A",
  cookie_accept: "\u5168\u90E8\u63A5\u53D7",
  cookie_reject: "\u62D2\u7EDD\u975E\u5FC5\u8981 Cookie",
  // Create Project Modal
  create_new_project: "\u65B0\u9879\u76EE",
  create_extracting: "\u63D0\u53D6\u4E2D...",
  create_select_problems: "\u9009\u62E9\u9898\u76EE",
  create_select_topics: "\u9009\u62E9\u4E3B\u9898",
  create_new_video: "\u65B0\u89C6\u9891",
  create_new_hw: "\u65B0\u4F5C\u4E1A\u9879\u76EE",
  create_new_lecture: "\u65B0\u8BFE\u7A0B\u9879\u76EE",
  create_new_self_study: "新项目",
  create_video: "\u89C6\u9891",
  create_homework: "\u4F5C\u4E1A",
  create_lecture: "\u8BFE\u7A0B",
  create_self_study: "项目",
  create_video_sub: "\u751F\u6210\u89C6\u9891",
  create_hw_sub: "\u4E0A\u4F20\u4F5C\u4E1A",
  create_lecture_sub: "\u4E0A\u4F20\u8BFE\u4EF6",
  create_self_study_sub: "\u9009\u62E9\u4E3B\u9898",
  create_video_prompt: "\u89C6\u9891\u5E94\u8BE5\u89E3\u91CA\u4EC0\u4E48\uFF1F",
  create_project_title: "\u9879\u76EE\u6807\u9898",
  create_video_hint: "\u8FD9\u5C06\u540C\u65F6\u4F5C\u4E3A\u6807\u9898\u548C\u89C6\u9891\u63D0\u793A\u8BCD\u3002",
  create_drop_hw: "\u5C06\u4F5C\u4E1A\u62D6\u653E\u5230\u6B64\u5904",
  create_drop_lecture: "\u5C06\u8BFE\u4EF6\u62D6\u653E\u5230\u6B64\u5904",
  create_file_types: "PDF\u3001PNG\u3001JPG\u3001HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "放下来开始一个项目",
  create_reading_hw: "\u6B63\u5728\u8BFB\u53D6\u4F60\u7684\u4F5C\u4E1A",
  create_reading_lecture: "\u6B63\u5728\u8BFB\u53D6\u4F60\u7684\u8BFE\u4EF6",
  create_finding_problems: "\u6B63\u5728\u67E5\u627E\u548C\u63D0\u53D6\u9898\u76EE...",
  create_finding_topics: "\u6B63\u5728\u63D0\u53D6\u4E3B\u9898...",
  create_add_video: "\u6DFB\u52A0\u89C6\u9891",
  create_add_more_files: "\u6DFB\u52A0\u66F4\u591A\u6587\u4EF6",
  create_starting: "\u5F00\u59CB\u751F\u6210...",
  create_generate_video: "\u751F\u6210\u89C6\u9891 \u00B7 1 \u79EF\u5206",
  create_generate_n: "\u751f\u6210 {n, plural, other {# \u4e2a\u89c6\u9891}} \u00B7 {n, plural, other {# \u79ef\u5206}}",
  create_create_project: "\u521b\u5efa\u9879\u76ee \u00B7 {n, plural, other {# \u79ef\u5206}}",
  create_no_problems: "\u672A\u627E\u5230\u9898\u76EE\u3002\u8BF7\u5C1D\u8BD5\u66F4\u6E05\u6670\u7684\u7167\u7247\u6216\u4E0D\u540C\u9875\u9762\u3002",
  create_no_topics: "\u672A\u627E\u5230\u4E3B\u9898\u3002\u8BF7\u5C1D\u8BD5\u66F4\u6E05\u6670\u7684\u7167\u7247\u6216\u4E0D\u540C\u6587\u4EF6\u3002",
  create_error: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  create_extract_daily_limit: "这就是今天的所有文件。明天还有更多。",
  create_video_topic_placeholder: "\u89C6\u9891 {n} \u4E3B\u9898\uFF0C\u4F8B\u5982\"\u7279\u5F81\u503C\u4E0E\u7279\u5F81\u5411\u91CF\"",
  video_share: "\u5206\u4EAB",
  // and made the two indistinguishable.
  video_followup_placeholder: "生成后续视频...",
  video_chip_simpler: "\u7B80\u5355\u89E3\u91CA",
  video_chip_harder: "\u66F4\u96BE\u7684\u4F8B\u5B50",
  video_chip_real_world: "\u5B9E\u9645\u5E94\u7528",
  // spends a credit generating a new one.
  video_ask_title: "询问这个视频",
  video_ask_cta: "聊聊这个",
  video_ask_placeholder: "问一个问题...",
  video_ask_thinking: "思维...",
  video_ask_close: "关闭",
  video_ask_chip_explain: "解释一下那部分",
  video_ask_chip_example: "举个例子",
  video_ask_chip_why: "为什么这样有效？",
  video_ask_limit_reached: "您已达到今天的问题限制。明天就重置了",
  video_up_next: "\u63A5\u4E0B\u6765",
  video_no_suggested: "\u6682\u65E0\u63A8\u8350\u89C6\u9891",
  video_untitled: "\u65E0\u6807\u9898\u89C6\u9891",
  video_created_recently: "\u6700\u8FD1\u521B\u5EFA",
  video_just_now: "\u521A\u521A",
  video_minutes_ago: "{n, plural, other {# \u5206\u949f}}\u524d",
  video_hours_ago: "{n, plural, other {# \u5c0f\u65f6}}\u524d",
  video_days_ago: "{n, plural, other {# \u5929}}\u524d",
  video_weeks_ago: "{n, plural, other {# \u5468}}\u524d",
  video_months_ago: "{n, plural, other {# \u4e2a\u6708}}\u524d",
  video_years_ago: "{n, plural, other {# \u5e74}}\u524d",
  video_unknown_date: "\u672A\u77E5\u65E5\u671F",
  video_download_error: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  // Search Results
  search_no_results: "\u672A\u627E\u5230\u7ED3\u679C",
  search_no_results_for: "\u672A\u627E\u5230\u201C{query}\u201D\u7684\u7ED3\u679C",
  search_all_videos: "\u641C\u7D22\u6240\u6709\u89C6\u9891",
  search_enter_term: "\u8F93\u5165\u641C\u7D22\u8BCD\u67E5\u627E\u89C6\u9891",
  search_retry: "\u91CD\u65B0\u641C\u7D22",
  auth_continue_google: "\u4F7F\u7528 Google \u7EE7\u7EED",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "立即开始我的访问。我了解这意味着我放弃 {days} 天的提款权和获得退款的权利。",
  home_sub_waiver_required: "请确认这一点以继续。",
  home_sub_agree_prefix: "继续，即表示您同意我们的",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "您必须年满 {age} 或以上才能使用 Magi。",
  auth_agree_prefix: "\u767B\u5F55\u5373\u8868\u793A\u60A8\u540C\u610F\u6211\u4EEC\u7684",
  auth_terms: "\u670D\u52A1\u6761\u6B3E",
  auth_and: "\u548C",
  auth_privacy: "\u9690\u79C1\u653F\u7B56",
  auth_email_optin: "向我发送提示和更新",
  // Auth modal (Google + email/password)
  auth_signin_title: "登录 Magi",
  auth_signin_desc: "从上次停下的地方继续。",
  auth_signup_title: "创建您的帐户",
  auth_signup_desc: "免费开始，无需卡。",
  auth_or: "或者",
  auth_continue_email: "继续使用电子邮件",
  auth_signing_in: "正在登录...",
  auth_working: "只需一秒钟...",
  auth_email_placeholder: "电子邮件",
  auth_password_placeholder: "密码",
  auth_signin_submit: "登入",
  auth_signup_submit: "创建账户",
  auth_no_account: "新来的？",
  auth_signup_link: "创建一个帐户",
  auth_have_account: "已经有帐户？",
  auth_signin_link: "登入",
  auth_forgot_password: "忘记密码了吗？",
  auth_reset_title: "重置您的密码",
  auth_reset_desc: "我们将通过电子邮件向您发送一个链接以设置新的链接。",
  auth_reset_submit: "发送重置链接",
  auth_reset_sent: "检查您的电子邮件中是否有重置链接。",
  auth_back_to_signin: "返回登录",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "确认您的电子邮件以继续",
  verify_wall_desc: "我们向 {email} 发送了确认链接。单击它，然后返回此处。",
  verify_wall_check: "我已经确认了",
  verify_wall_checking: "检查...",
  verify_wall_still_unverified: "尚未确认。单击电子邮件中的链接，然后重试。",
  verify_wall_resend: "再次发送链接",
  verify_wall_resent: "发送。检查您的收件箱和垃圾邮件文件夹。",
  verify_wall_wrong_account: "帐号错误？登出",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "确认您的电子邮件",
  verify_action_working_desc: "一会儿。",
  verify_action_done_title: "你已经准备好了",
  verify_action_done_desc: "您的电子邮件已确认。欢迎来到 Magi。",
  verify_action_done_cta: "开始学习",
  verify_action_failed_title: "该链接无效",
  verify_action_failed_desc: "它可能已经被使用过，或者已经过期。回去给自己寄一张新的。",
  verify_action_failed_cta: "返回 Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "登录观看",
  auth_watch_desc: "创建一个免费帐户来播放该视频。",
  auth_watch_ready_title: "您的视频已准备就绪",
  auth_watch_ready_desc: "登录观看 - 它将保存到您的帐户中。",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "登录才能下载",
  auth_download_desc: "创建一个免费帐户来保存该视频。",
  auth_ask_title: "登录询问",
  auth_ask_desc: "创建一个免费帐户来询问此视频。",
  auth_browse_title: "登录浏览",
  auth_browse_desc: "创建一个免费帐户来探索每节课。",
  auth_workspace_title: "登录查看您的作品",
  auth_workspace_desc: "您的课程和项目都在您的帐户中。",
  auth_generate_title: "登录以继续创作",
  auth_generate_desc: "免费帐户每天都会收到一个视频。",
  video_restricted: "该视频尚不可用。",
  // Share sheet
  share_title: "分享这个视频",
  share_desc_mobile: "将其发布到您的故事、发送给朋友或复制链接。",
  share_desc_desktop: "复制链接，或从手机下载要发布的视频。",
  share_to_apps: "分享到 Instagram 等",
  share_copy_link: "复制链接",
  share_copied: "链接已复制",
  share_download: "下载视频",
  share_preparing: "准备好……",
  share_watermark_note: "共享视频包括 magicacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "欢迎来到魔法师",
  welcome_subtitle: "您有 4 个免费视频可供开始。",
  welcome_optin_reward: "+1 个免费视频",
  welcome_continue: "继续",
  age_gate_continue: "继续",
  age_gate_saving: "保存...",
  // Landing Page
  landing_hero: "输入主题。",
  landing_hero2: "获取视频课程。",
  landing_subtitle: "Magi 可以在几分钟内将任何主题变成精美的动画、带旁白的视频。无需拍摄，无需剪辑，无需专业知识。",
  landing_signup_google: "使用 Google 注册",
  landing_signing_in: "\u767B\u5F55\u4E2D...",
  landing_chat_bubble: "GPS如何利用相对论？",
  landing_stats_title: "受到全世界学习者的信赖",
  landing_stat_videos: "3,000+",
  landing_stat_videos_desc: "生成的视频",
  landing_stat_languages_desc: "语言",
  landing_stat_speed: "约 1 分钟",
  landing_stat_speed_desc: "生成时间",
  landing_feature_lecture_title: "放下您的课堂笔记，获取视频",
  landing_feature_lecture_desc: "上传您的幻灯片或笔记。 Magi 提取每个主题并为每个主题生成一个视频解释。",
  landing_feature_hw_title: "被作业困住了？上传吧。",
  landing_feature_hw_desc: "放下一组问题，Magi 会提取每个问题，然后通过分步视频引导您完成解决方案。",
  landing_feature_chat_title: "观看时提出问题",
  landing_feature_chat_desc: "每个视频都配有可以与您聊天的人工智能导师。提出后续问题，获得更深入的解释，或者请求有关您想要更好地理解的特定部分的新视频。",
  landing_feature_lang_title: "用您的语言学习",
  landing_feature_lang_desc: "Magi 生成英语、西班牙语、印地语、中文、日语等视频。用任何语言输入您的主题，然后获得以该语言进行完整叙述的课程。",
  landing_cta_title: "几秒钟内开始学习",
  landing_cta_google: "继续使用谷歌",
  // Onboarding Bubbles
  onboarding_step1: "\u8FD9\u4E0D\u662F\u804A\u5929\u673A\u5668\u4EBA \u2014 \u8F93\u5165\u4E3B\u9898\uFF0C\u6211\u4F1A\u4E3A\u4F60\u751F\u6210\u4E00\u4E2A\u5B8C\u6574\u7684\u89C6\u9891\u8BFE\u7A0B\uFF01",
  onboarding_step2: "\u6216\u8005\u62D6\u5165 PDF \u6216\u7167\u7247 \u2014 \u6211\u4F1A\u628A\u6BCF\u9053\u9898\u53D8\u6210\u9010\u6B65\u89E3\u9898\u89C6\u9891",
  onboarding_step3: "\u70B9\u51FB\u5F00\u59CB\uFF0C\u89C6\u9891\u4F1A\u52A0\u5165\u961F\u5217\u3002\u751F\u6210\u65F6\u4F60\u53EF\u4EE5\u7EE7\u7EED\u6D4F\u89C8\uFF01",
  onboarding_generating: "这是你在几分钟内学到的教训。如果您愿意，请继续浏览；准备好后它就会降落在这里。",
  onboarding_skip: "\u8DF3\u8FC7",
  onboarding_next: "\u4E0B\u4E00\u6B65",
  onboarding_done: "\u77E5\u9053\u4E86\uFF01",
  // Generating Cards Row
  generating_label: "\u751F\u6210\u4E2D",
  // Lecture Session (Self Study)
  lecture_loading: "\u52A0\u8F7D\u4E2D...",
  lecture_fallback_title: "\u8BFE\u7A0B",
  lecture_building: "\u6B63\u5728\u751F\u6210\u89C6\u9891...",
  lecture_building_time: "\u901A\u5E38\u9700\u8981 2-4 \u5206\u949F",
  lecture_failed: "\u89C6\u9891\u751F\u6210\u5931\u8D25",
  lecture_no_video: "\u6682\u65E0\u89C6\u9891",
  lecture_followup: "\u540E\u7EED\u95EE\u9898",
  lecture_now_playing: "\u6B63\u5728\u64AD\u653E",
  lecture_tab_videos: "\u89C6\u9891",
  lecture_tab_chat: "\u804A\u5929",
  lecture_chat_empty: "\u5173\u4E8E\u8FD9\u4E2A\u4E3B\u9898\uFF0C\u968F\u4FBF\u95EE",
  lecture_chat_chip1: "\u7B80\u5355\u89E3\u91CA",
  lecture_chat_chip2: "\u4E3E\u4E2A\u4F8B\u5B50",
  lecture_chat_chip3: "\u8FD9\u6709\u4EC0\u4E48\u7528\uFF1F",
  lecture_chat_placeholder: "\u5173\u4E8E\u8FD9\u4E2A\u4E3B\u9898\u63D0\u95EE...",
  lecture_followup_placeholder: "\u6DFB\u52A0\u540E\u7EED\u89C6\u9891...",
  lecture_chat_error: "\u62B1\u6B49\uFF0C\u65E0\u6CD5\u5904\u7406\u3002\u8BF7\u91CD\u8BD5\u3002",
  lecture_chat_generic_error: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "作业PDF",
  home_sc_hw_desc: "上传问题集，为每个问题获取一个视频",
  home_sc_lecture_title: "讲座PDF",
  home_sc_lecture_desc: "将幻灯片或笔记变成一系列课程",
  home_sc_course_title: "创建课程",
  home_sc_course_desc: "针对一个主题计划一系列课程",
  // Misc
  generic_error: "\u51FA\u4E86\u70B9\u95EE\u9898\uFF0C\u8BF7\u91CD\u8BD5\u3002",
  loading: "\u52A0\u8F7D\u4E2D...",
};

export default zh;
